import { fetchAPIWithID } from "../config";

export async function updateUser(user) { 
  const data = await fetchAPIWithID("/ssm_api_user/updateuser", user);
  return data;
}
